import { formatDateTime } from '@/lib/format'
import { messages } from '@/lib/messages'
import type { HrRequest, HrRequestDetail } from '@/services/http/hr'
import { formatLeaveRange } from '@/features/hr/request-value'

const t = messages.hr
const r = t.approvals

export function isLeaveKind(kind: HrRequest['kind'] | undefined): boolean {
  return kind === 'izin_guncelle' || kind === 'izin_iptal'
}

/** Talebin hedef sistemine göre metinler: giriş/çıkış DİA'ya, izin Passgage'e gider. */
export function targetCopy(request: Pick<HrRequest, 'kind'> | undefined) {
  return isLeaveKind(request?.kind) ? r.leave : r
}

/** Tablodaki tip ve zaman sütunları: giriş/çıkışta yön + an, izinde istenen tür + aralık. */
export function requestSummary(request: HrRequest): { tip: string; zaman: string } {
  if (request.kind === 'izin_iptal' && request.leave_old) {
    return { tip: request.leave_old.tur, zaman: formatLeaveRange(request.leave_old) }
  }
  if (request.leave_new) {
    return { tip: request.leave_new.tur, zaman: formatLeaveRange(request.leave_new) }
  }
  return {
    tip: request.giris_cikis ? t.girisCikis[request.giris_cikis] : t.unknown,
    zaman: formatDateTime(request.occurred_at),
  }
}

/** Revizyondaki talebin son revizyon nedeni (kim, ne zaman, ne dedi); yoksa null. */
export function lastRevision(request: HrRequestDetail) {
  if (request.status !== 'revizyonda') return null
  return request.events.findLast((event) => event.kind === 'revizyon_istendi') ?? null
}

/** "Onayla" pasifse nedeni (izin yoksa düğme hiç görünmez). */
export function approveDisabledReason(request: HrRequest): string | null {
  if (request.can_approve) return null
  return request.status === 'onay_bekliyor' ? r.approveDisabled.scope : r.approveDisabled.status
}

export interface RequestListFilter {
  firma: string
  kind: string
  q: string
}

/** Onaylar listesinin ekran süzgeci: firma, tür ve kişi/sicil/açan araması (Türkçe büyük-küçük). */
export function filterRequests<T extends HrRequest>(rows: T[], filter: RequestListFilter): T[] {
  const needle = filter.q.trim().toLocaleLowerCase('tr')
  return rows.filter(
    (row) =>
      (!filter.firma || row.firma === filter.firma) &&
      (!filter.kind || row.kind === filter.kind) &&
      (!needle ||
        [row.personel_adi, row.sicilno, row.created_by.name].some((value) =>
          (value ?? '').toLocaleLowerCase('tr').includes(needle),
        )),
  )
}
